import React from 'react';
import { BlastChillingCyclePage } from './PositiveBlastChillingPage';

export default function NegativeBlastChillingPage() {
  return <BlastChillingCyclePage variant="negative" />;
}
